import { Component } from '@angular/core';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { LendersSolicitorService } from '../../shared/services/lenders-solicitor.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { LenderSolicitorDetailsComponent } from '../lender-solicitor-details/lender-solicitor-details.component';
import { TableColumn } from 'src/app/shared/components/table/table-column.interface';
import { TableSearchRequest } from 'src/app/shared/components/table/table.component';

@Component({
  selector: 'app-lender-solicitors-list',
  templateUrl: './lender-solicitors-list.component.html',
  styleUrls: ['./lender-solicitors-list.component.scss']
})
export class LenderSolicitorsListComponent {

  lenderSolicitors: any[] = [];
  resultsLength: number = 0;
  isLoadingResults: boolean = false;
  lastRequest?: TableSearchRequest;
  faPlus = faPlus;

  columns: TableColumn[] = [
    { key: 'name',     label: 'Name',   sortable: true, filterable: true },
    { key: 'isActive', label: 'Active', sortable: true, filterable: true, filterType: 'select',
      filterOptions: [
        { label: 'Yes', value: '{{bool}}true' },
        { label: 'No',  value: '{{bool}}false' }
      ]
    },
  ];

  constructor(
    private lenderSolService: LendersSolicitorService,
    public modalService: ModalService) {
  }

  onSearch(request: TableSearchRequest) {
    this.lastRequest = request;
    this.isLoadingResults = true;
    this.lenderSolService.getSolicitorsPaged(request).subscribe({
      next: data => {
        this.lenderSolicitors = data.items;
        this.resultsLength = data.recordCount;
        this.isLoadingResults = false;
      },
      error: () => this.isLoadingResults = false
    });
  }

  editLenderSol(lenderSol: any) {
    const modalRef = this.modalService.openWithOptions(LenderSolicitorDetailsComponent, { size: 'lg', scrollable: true });
    modalRef.componentInstance.lenderSolicitorId = lenderSol.id;
    modalRef.result.then(
      (result) => { if (result) this.onSearch(this.lastRequest!); },
      () => {}
    );
  }

  addLenderSol() {
    const modalRef = this.modalService.openWithOptions(LenderSolicitorDetailsComponent, { size: 'lg', scrollable: true });
    modalRef.result.then(
      (result) => { if (result) this.onSearch(this.lastRequest!); },
      () => {}
    );
  }
}